/* eslint-disable import/prefer-default-export */
export const qrCodeRef = 'qr-code'
